import LIB from '../utility/Library'

let CONSTANT =  {
  FPS         : 60,
  FORCE_BASE  : 60,
  SCROLL: {
    AREA   : 150, // エリア上下の余白
    PADDING: LIB.isPc ? 150 : 300,
    WAIT   : 140 // スクロール完了とみなすms
  },
  DATA: {
    FORCE: 'force',
    TYPE : 'type',
    SLANT: 'slant'
  },
  CLASSNAME: {
    SCROLL    : 'js-scroll',
    TRANSITION: 'can-transit',
    ACTIVE    : 'is-active',
    VISIBLE   : 'is-visible',
    LEAVE     : 'is-leave',
    SCROLLING : 'is-scrolling',
    FRICTION  : 'has-force',
    ILLUST    : 'has-force',
    SPEEDY    : 'is-speedy'
  },
  BEZIER: {
    ACTION: {
      IN : 'fadein',
      IUT: 'fadeout'
    }
  }
}

CONSTANT.FRAME_TIME = 1000 / CONSTANT.FPS

export default CONSTANT


// WEBPACK FOOTER //
// ./src/assets/js/config/constant.js